module.exports = __webpack_public_path__ + "img/w3_technical_black.d90bdc03.png";